export class InvalidCredentialsError extends Error {}
